

export const getAPI = (path) => {
  const url = window.location;
  if (url.hostname === 'localhost') {
    return `http://localhost:8000${path}`;
  }
  return `${url.protocol}//api.${url.host}${path}`;
}
